module.exports = __webpack_public_path__ + "799941b3ede44ecc19217a7a5bfc9393.png";